import React, { Suspense, useState } from "react";
import {
  Alert,
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import LeftBG from "../assets/images/Vector52.png";
import LogoDesa from "../assets/images/register/desapedia.png";
import { config } from "../config";
import LoadingOverlay from "../component/Loading";
import axios from "axios";

const SigninForm = () => {
  const [modal, setModal] = useState(false);
  const [modalAwareness, setModalAwareness] = useState(true);
  const [form, setForm] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({
    message: "",
  });

  const [visibleError, setVisibleError] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const onDismiss = () => setVisibleError(false);
  const toggle = () => setModal(!modal);
  const toggleError = () => setModalError(!modalError);
  const toggleSuccess = () => setModalSuccess(!modalSuccess);

  const PreLoader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      </div>
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // --- FUNGSI VALIDASI EMAIL ---
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = async () => {
    toggle();
    setLoading(true);
    try {
      const dataToSend = {
        ...form,
        createdBy: "User Landing Page",
      };

      const headers = {
        "Content-Type": "application/json",
        // apikey: config.API_KEY,
      };

      const response = await axios.post(
        `${config.BASE_URL}registerDraft/create`,
        dataToSend,
        { headers }
      );

      if (response.status === 200) {
        setLoading(false);
        toggleSuccess();
      }
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setModalError(true);
      setLoading(false);
    }
  };

  const handleConfirm = (event) => {
    event.preventDefault();

    // 2. Validasi Email (TAMBAHAN BARU)
    if (!validateEmail(form.email)) {
      setVisibleError(true);
      setErrors({
        message: "Format Email tidak valid (contoh: user@mail.com)",
      });
      return;
    }

    // Jika semua valid
    setVisibleError(false);
    toggle();
    setErrors({ message: "" });
  };

  return (
    <React.Fragment>
      {loading && <LoadingOverlay />}

      <Modal
        isOpen={modalAwareness}
        toggle={() => setModalAwareness(false)}
        centered
        contentClassName="border-0 bg-transparent"
      >
        <div style={{ backgroundColor: '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <div style={{ backgroundColor: '#ff5c30', padding: '30px 20px', textAlign: 'center', position: 'relative' }}>
            <div style={{
              width: '60px', height: '60px', backgroundColor: 'rgba(255,255,255,0.2)',
              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 15px auto'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" viewBox="0 0 16 16">
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
              </svg>
            </div>
            <h4 style={{ color: 'white', fontWeight: '700', margin: 0 }}>Pemberitahuan</h4>
            <button
              onClick={() => setModalAwareness(false)}
              style={{ position: 'absolute', top: '15px', right: '15px', background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', opacity: 0.8 }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" /></svg>
            </button>
          </div>

          <ModalBody className="p-4">
            <div className="text-center mb-4">
              <p style={{ fontSize: '15px', color: '#555', lineHeight: '1.6' }}>
                Halo! Jika Anda <strong>sudah pernah mendaftarkan email</strong> namun belum menyelesaikan pengisian data, ikuti langkah berikut:
              </p>
            </div>

            <div style={{ backgroundColor: '#fff9f7', padding: '15px', borderRadius: '12px', borderLeft: '4px solid #ff5c30', marginBottom: '15px' }}>
              <div className="d-flex align-items-center mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "10px" }} width="18" height="18" fill="#ff5c30" className="me-2" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" /></svg>
                <strong style={{ color: '#333' }}>Periksa Kotak Masuk</strong>
              </div>
              <p className="mb-0 text-muted" style={{ fontSize: '14px', marginLeft: '26px' }}>Silakan periksa kotak masuk (Inbox) atau folder <strong>Spam</strong> pada email Anda.</p>
            </div>

            <div style={{ backgroundColor: '#fff9f7', padding: '15px', borderRadius: '12px', borderLeft: '4px solid #ff5c30' }}>
              <div className="d-flex align-items-center mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "10px" }} width="18" height="18" fill="#ff5c30" className="me-2" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" /></svg>
                <strong style={{ color: '#333' }}>Gunakan Tautan</strong>
              </div>
              <p className="mb-0 text-muted" style={{ fontSize: '14px', marginLeft: '26px' }}>Gunakan <strong>link pendaftaran</strong> yang telah kami kirimkan untuk melanjutkan proses.</p>
            </div>
          </ModalBody>

          <div className="p-4 pt-0">
            <Button
              className="w-100 py-2 fw-bold"
              style={{ background: "#ff5c30", border: "none", borderRadius: '10px', boxShadow: '0 4px 10px rgba(255, 92, 48, 0.3)', transition: 'all 0.3s' }}
              onClick={() => setModalAwareness(false)}
            >
              Saya Mengerti
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal Success */}
      <Modal isOpen={modalSuccess} toggle={toggleSuccess} centered>
        <ModalBody>
          <Alert>
            <h4 className="alert-heading">Register Sukses!</h4>
            <p>
              Tautan pengisian formulir telah dikirim ke{" "}
              <strong>{form.email}</strong>. Segera cek kotak masuk atau folder{" "}
              <em>spam</em> Anda untuk melanjutkan.
            </p>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalSuccess(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Error */}
      <Modal isOpen={modalError} toggle={toggleError} centered>
        <ModalBody>
          {errorMessage
            ? errorMessage
            : "Maaf register saat ini tidak dapat dilakukan. Silahkan coba beberapa saat lagi"}
        </ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalError(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Konfirmasi */}
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalBody>Apakah Anda yakin ingin mengirim data berikut?</ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={onSubmit}
          >
            Iya
          </Button>
          <Button style={{ background: "gray" }} size="sm" onClick={toggle}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>

      <Suspense fallback={PreLoader}>
        <Container id="register-partner">
          <button
            style={{
              position: "absolute",
              zIndex: "100",
              left: 32,
              top: 24,
              background: "transparent",
              border: 0,
            }}
            onClick={() => (window.location.href = "/")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="white"
              className="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              />
            </svg>
          </button>

          <img src={LeftBG} alt="" />
          <div className="separator">
            <img src={LogoDesa} alt="desapedia" />
            <div className="form">
              <h1>Register</h1>
              {errors.message && (
                <Alert color="danger" isOpen={visibleError} toggle={onDismiss}>
                  {errors.message}
                </Alert>
              )}

              <form action="" onSubmit={handleConfirm}>
                <label htmlFor="email">Email</label>
                <input
                  name="email"
                  type="text"
                  id="email"
                  value={form.email}
                  onChange={handleInputChange}
                  placeholder="Isi Email Anda"
                />

                <input
                  type="submit"
                  value="Register"
                  disabled={!form.email}
                />
              </form>
            </div>
          </div>
        </Container>
      </Suspense>
    </React.Fragment>
  );
};

export default SigninForm;
